export const SUB_COLLECTION_NAME = {
    MYPATH: 'myPath',
    LIKES: 'likes',
    FAVORITES: 'favorites',
    RECRUITEDS: 'recruiteds',
    MESSAGES: 'messages',
    PARTICIPANTS: 'participants',
    AVATAR: 'avatar'
}